/**
 * Route for `datacenter-ip-database-aws-gcp-azure-do-linode-ovh`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DatacenterIpDatabaseAwsGcpAzureDoLinodeOvhPage } from "../features/datacenter-ip-database-aws-gcp-azure-do-linode-ovh/DatacenterIpDatabaseAwsGcpAzureDoLinodeOvhPage";

export const datacenterIpDatabaseAwsGcpAzureDoLinodeOvhRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/datacenter-ip-database-aws-gcp-azure-do-linode-ovh",
	component: DatacenterIpDatabaseAwsGcpAzureDoLinodeOvhPage,
});

export default datacenterIpDatabaseAwsGcpAzureDoLinodeOvhRoute;
